var React = require('react');

function StepCircle1060px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-7.222-18h1.692V18.6h-1.584l-4.428 2.628.432 1.368 3.816-2.232h.072V42zm13.94.396h-.036c-3.672 0-7.056-3.6-7.164-11.988 0-8.496 3.744-12.204 7.668-12.204 4.104 0 7.164 3.708 7.164 11.772 0 8.388-3.024 12.42-7.632 12.42zm.144-1.44h.036c3.888 0 5.652-4.428 5.652-10.8 0-6.12-1.656-10.512-5.616-10.512-3.384 0-5.616 4.32-5.616 10.512-.108 6.516 2.124 10.8 5.544 10.8z"}));
}

StepCircle1060px.displayName = "StepCircle1060px";

StepCircle1060px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle1060px;

StepCircle1060px.default = StepCircle1060px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-10-60px.svg
// module id = 1215
// module chunks = 0